export default "__VITE_ASSET__Cbz_KO4V__"